module.exports = __webpack_public_path__ + "static/media/bed-icon.1ae892a8.svg";